module.exports = __webpack_public_path__ + "static/assets/55fbbef2dfcc37fb22658e968cda0a67.png";